query allUltimateTeams(
  $first: Int,
  $offset: Int,
  $filter: UltimateTeamFilter,
  ) {
  teams: allUltimateTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      teamMappings: ultimateTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
      name
      source
      teamId
    }
    totalCount
  }
}
